module.exports = __webpack_public_path__ + "static/media/logo2.bb3dc68c.png";